import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';

const HipeBanner = () => {
  let maxLetter = 12;
  const componentRef = useRef(null);
  const [leftUsername, setLeftUsername] = useState('');
  const [rightUsername, setRightUsername] = useState('');
  const [leftImage, setLeftImage] = useState(null);
  const [rightImage, setRightImage] = useState(null);
  const [battleDate, setBattleDate] = useState('');
  const [battleTime, setBattleTime] = useState('');
  const [leftFamilyName, setLeftFamilyName] = useState('');
  const [rightFamilyName, setRightFamilyName] = useState('');
  const [loadingD, setLoadingD] = useState(false);

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const formattedHours = ((+hours % 12) || 12).toString();
    const ampm = +hours >= 12 ? 'PM' : 'AM';
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const handleDownload = () => {
    setLoadingD(true);
    if (componentRef.current) {
      html2canvas(componentRef.current, { useCORS: true }).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'Family_PK_Battle_Overlay.png';
        link.click();
        setLoadingD(false);
      });
    } else {
      setLoadingD(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Create PK Battle Banner - HIPE LIVE</h2>

      <form className="mb-4">
        {/* Usernames */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Left Username</label>
            <input
              type="text"
              className="form-control"
              value={leftUsername}
              onChange={(e) => setLeftUsername(e.target.value)}
              placeholder="Enter left username"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Right Username</label>
            <input
              type="text"
              className="form-control"
              value={rightUsername}
              onChange={(e) => setRightUsername(e.target.value)}
              placeholder="Enter right username"
            />
          </div>
        </div>

        {/* Family Names */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Left UserId</label>
            <input
              type="text"
              className="form-control"
              value={leftFamilyName}
              onChange={(e) => setLeftFamilyName(e.target.value)}
              placeholder="Enter left userId"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Right UserId</label>
            <input
              type="text"
              className="form-control"
              value={rightFamilyName}
              onChange={(e) => setRightFamilyName(e.target.value)}
              placeholder="Enter right userId"
            />
          </div>
        </div>

        {/* Image Uploads */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Left Image</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => handleImageUpload(e, setLeftImage)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Right Image</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => handleImageUpload(e, setRightImage)}
            />
          </div>
        </div>

        {/* Date & Time */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Battle Date</label>
            <input
              type="date"
              className="form-control"
              value={battleDate}
              onChange={(e) => setBattleDate(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Battle Time</label>
            <input
              type="time"
              className="form-control"
              value={battleTime}
              onChange={(e) => setBattleTime(e.target.value)}
            />
          </div>
        </div>
      </form>

      {/* Banner Preview */}
      <div
        ref={componentRef}
        style={{
          position: 'relative',
          width: '600px',
          height: '600px',
          margin: '0 auto',
          backgroundColor: '#333',
        }}
      >
        <img
          src="/hipe_pk.png"
          alt="Background"
          style={{ width: '100%', height: '100%' }}
        />

        {leftImage && (
          <div
            style={{
              position: 'absolute',
              bottom: '252px',
              left: '52px',
              width: '180px',
              height: '180px',
              padding: '5px',
              borderRadius: '100%',
              boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.5)',
            }}
          >
            <img
              src={leftImage}
              alt="Left User"
              style={{ width: '100%', height: '100%', borderRadius: '100%' }}
            />
          </div>
        )}

        {rightImage && (
          <div
            style={{
              position: 'absolute',
              bottom: '252px',
              right: '55px',
              width: '180px',
              height: '180px',
              padding: '5px',
              borderRadius: '100%',
              boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.5)',
            }}
          >
            <img
              src={rightImage}
              alt="Right User"
              style={{ width: '100%', height: '100%', borderRadius: '100%' }}
            />
          </div>
        )}

        {/* Family Names */}
        <div
          style={{
            position: 'absolute',
            bottom: '180px',
            left: '106px',
            color: '#FFFFFF',
            fontWeight: '900',
            fontSize: '14px',
          }}
        >
          {leftFamilyName?.length > maxLetter
            ? `${capitalizeFirstLetter(leftFamilyName.slice(0, maxLetter))}...`
            : capitalizeFirstLetter(leftFamilyName) || 'Left UserId'}
        </div>

        <div
          style={{
            position: 'absolute',
            bottom: '180px',
            right: '106px',
            color: '#FFFFFF',
            fontWeight: '900',
            fontSize: '14px',
          }}
        >
          {rightFamilyName?.length > maxLetter
            ? `${capitalizeFirstLetter(rightFamilyName.slice(0, maxLetter))}...`
            : capitalizeFirstLetter(rightFamilyName) || 'Right UserId'}
        </div>

        {/* Usernames */}
        <div
          style={{
            position: 'absolute',
            bottom: '144px',
            left: '94px',
            color: '#e1dd14ff',
            fontWeight: '900',
            fontSize: '18px',
          }}
        >
          {leftUsername?.length > maxLetter - 2
            ? `${leftUsername.slice(0, maxLetter - 2)}...`
            : leftUsername || 'Left User'}
        </div>

        <div
          style={{
            position: 'absolute',
            bottom: '144px',
            right: '95px',
            color: '#e1dd14ff',
            fontWeight: '900',
            fontSize: '18px',
          }}
        >
          {rightUsername?.length > maxLetter - 2
            ? `${rightUsername.slice(0, maxLetter - 2)}...`
            : rightUsername || 'Right User'}
        </div>

        {/* Date & Time */}
        <div
          style={{
            position: 'absolute',
            bottom: '24px',
            width: '100%',
            textAlign: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          <svg width="100%" height="80">
            <text x="50%" y="50%" fontSize="18" fontWeight="bold" fill="white" textAnchor="middle" dominantBaseline="middle">
              {battleTime && battleDate &&
                `Time: ${formatTime(battleTime)}, Date: ${new Date(battleDate).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: '2-digit' })}`}
            </text>
          </svg>
        </div>
      </div>

      {/* Download Button */}
      <button
        onClick={handleDownload}
        className="btn btn-primary mt-3"
        disabled={loadingD}
        style={{ display: 'block', margin: '0 auto' }}
      >
        {loadingD ? "Downloading..." : "Download Image"}
      </button>
    </div>
  );
};

export default HipeBanner;
